// Import React
import React from "react";



// Export the reusable select field
export default function PodDesignAiSelectField({
    label,
    value,
    onChange,
    options,
    disabled,
    aiModelsInfoTable,
    setShowAiModelsTable,
}) {

    // Return the select field UI
    return (

        <div className="podDesignAiSelectField">

            {/* This is the field label */}
            <label className="podDesignAiSelectField__label">

                {label} 
                
                {aiModelsInfoTable && 
                
                    <span style={{cursor: "pointer", fontWeight: "normal"}} onClick={() => setShowAiModelsTable((prev) => !prev )}> 🛈</span>
                
                }

            </label>

            {/* This is the select input */}
            <select
                className="podDesignAiSelectField__select"
                value={value}
                onChange={(event) => onChange(event.target.value)}
                disabled={disabled}
            >

                {/* Loop through the options */}
                {options.map((option) => (

                    <option
                        key={option.value}
                        value={option.value}
                    >

                        {option.label}

                    </option>

                ))}

            </select>

        </div>

    );
    
}